import { render, staticRenderFns } from "./IconGood.vue?vue&type=template&id=30bfdfb1&scoped=true"
import script from "./IconGood.vue?vue&type=script&lang=js"
export * from "./IconGood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bfdfb1",
  null
  
)

export default component.exports